// import React, { useState } from 'react';
// import Select from 'react-select';

// const options = [
//   { value: 'apple', label: 'Apple' },
//   { value: 'banana', label: 'Banana' },
//   { value: 'orange', label: 'Orange' },
//   // Add more options as needed
// ];

// const TestParentComponent = () => {
//   const [selectedOptions, setSelectedOptions] = useState([]);
//   const [filteredOptions, setFilteredOptions] = useState(options);

//   const handleSelectChange = (selectedOptions) => {
//     setSelectedOptions(selectedOptions);
//   };

//   const handleFilterChange = (inputValue) => {
//     const filtered = options.filter(option =>
//       option.label.toLowerCase().includes(inputValue.toLowerCase())
//     );
//     setFilteredOptions(filtered);
//   };

//   const formatOptionLabel = ({ label, value }) => (
//     <div>
//       <input
//         type="checkbox"
//         checked={selectedOptions.some(option => option.value === value)}
//         onChange={() => handleCheckboxChange({ value, label })}
//       />
//       <span>{label}</span>
//     </div>
//   );

//   const handleCheckboxChange = (option) => {
//     const isSelected = selectedOptions.some(item => item.value === option.value);
//     if (option.value === 'select-all') {
//       if (isSelected) {
//         setSelectedOptions([]);
//       } else {
//         setSelectedOptions(filteredOptions);
//       }
//     } else {
//       const updatedOptions = isSelected
//         ? selectedOptions.filter(item => item.value !== option.value)
//         : [...selectedOptions, option];
//       setSelectedOptions(updatedOptions);
//     }
//   };

//   const optionsWithSelectAll = [
//     { value: 'select-all', label: 'Select All' },
//     ...filteredOptions,
//   ];

//   return (
//     <div>
//       <Select
//         options={optionsWithSelectAll}
//         isMulti
//         value={selectedOptions}
//         onChange={handleSelectChange}
//         onInputChange={handleFilterChange}
//         placeholder="Select..."
//         isSearchable
//         formatOptionLabel={formatOptionLabel}
//       />
//       <div>
//         Selected Options:
//         {selectedOptions.map(option => (
//           <span key={option.value}>{option.label}, </span>
//         ))}
//       </div>
//     </div>
//   );
// };


// export default TestParentComponent;


import React, { useState, useRef } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const TestParentComponent = () => {
  const initialItems = [
    { id: '1', content: 'Item 1' },
    { id: '2', content: 'Item 2' },
    { id: '3', content: 'Item 3' },
    { id: '4', content: 'Item 16' },
    { id: '5', content: 'Item 26' },
    { id: '6', content: 'Item 36' },
    { id: '7', content: 'Item 19' },
    { id: '8', content: 'Item 29' },
    { id: '9', content: 'Item 39' },
    { id: '10', content: 'Item 10' },
    { id: '21', content: 'Item 21' },
    { id: '31', content: 'Item 31' },
    { id: '11', content: 'Item 11' },
    { id: '22', content: 'Item 22' },
    { id: '32', content: 'Item 32' },
    { id: '12', content: 'Item 12' },
    { id: '22', content: 'Item 22' },
    { id: '32', content: 'Item 32' },
    { id: '14', content: 'Item 14' },
    { id: '24', content: 'Item 24' },
    { id: '34', content: 'Item 34' },
    { id: '14', content: 'Item 14' },
    { id: '25', content: 'Item 25' },
    { id: '35', content: 'Item 35' },
    { id: '16', content: 'Item 16' },
    { id: '26', content: 'Item 26' },
    { id: '36', content: 'Item 36' },
    // ... More items
  ];

  const [items, setItems] = useState(initialItems);
  const [searchTerm, setSearchTerm] = useState('');
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const containerRef = useRef(null);

  const handleDragEnd = ({ destination, source }) => {
    if (!destination) return;

    const reorderedItems = Array.from(items);
    const [movedItem] = reorderedItems.splice(source.index, 1);
    reorderedItems.splice(destination.index, 0, movedItem);

    setItems(reorderedItems);
    setHighlightedIndex(-1);
  };

  const navigateToHighlightedItem = () => {
    if (highlightedIndex !== -1 && containerRef.current) {
      const highlightedElement = containerRef.current.querySelector(`[data-index="${highlightedIndex}"]`);
      if (highlightedElement) {
        const offsetTop = highlightedElement.offsetTop;
        containerRef.current.scrollTop = offsetTop - containerRef.current.clientHeight / 2; // Scroll to the middle
      }
    }
  };

  return (
    <div>
      <input
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
       <button onClick={navigateToHighlightedItem}>Navigate to Highlighted Item</button>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="droppable">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={ref => {
                provided.innerRef(ref);
                containerRef.current = ref;
              }}
              style={{
                height: '300px',
                overflowY: 'auto',
                border: '1px solid gray',
                padding: '10px'
              }}
            >
              {items.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className={`item ${snapshot.isDragging && 'dragging'}`}
                      data-index={index} // Add data-index attribute for querySelector
                    >
                      {item.content}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
     
    </div>
  );
};

export default TestParentComponent;
